import { ConversationContextProvider } from 'src/provider/ConversationContext';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { useGatheringChatState } from '../../../GatheringSessions/gatheringChatState';
import { GatheringChatList } from './conversation/GatheringChatList';
import { GatheringChatContext } from './conversation/useGatheringChatContext';

export const GatheringChat = ({
  isGuest,
  onClose,
}: { isGuest: boolean; onClose(): void }) => {
  const { activeSessionId } = useLivekitRTCState();
  const { sessionId } = useGatheringChatState();

  return (
    <ConversationContextProvider>
      <GatheringChatContext sessionRef={sessionId!}>
        <GatheringChatList
          isGuest={isGuest}
          onClose={onClose}
          disabled={sessionId !== activeSessionId}
        />
      </GatheringChatContext>
    </ConversationContextProvider>
  );
};
